import React from "react";

export const PlatformRules = () => {
 return (
 <div className="space-y-6">
 <div className="bg-white p-6 rounded-lg shadow-md">
 <div className="text-center mb-6">
 <h2 className="text-2xl font-bold text-gray-900 mb-2">Правила платформы REVERSIA</h2>
 <p className="text-sm text-gray-600">Обязательны для исполнения всеми пользователями</p>
 <p className="text-xs text-gray-400 mt-2">Обновлено: {new Date().toLocaleDateString('ru-RU')}</p>
 </div>
 
 <div className="prose max-w-none text-gray-700 space-y-6">
 
 {/* 1. Система безопасных платежей (ESCROW) */}
 <div>
 <h3 className="text-xl font-semibold text-gray-800 mb-4">Система безопасных платежей (ESCROW)</h3>
 
 <div className="bg-green-50 p-4 rounded-lg border-l-4 border-green-400">
 <h4 className="font-semibold text-green-800 mb-3">1.1. Механизм оплаты:</h4>
 <ul className="list-disc list-inside space-y-2">
 <li>При принятии задания исполнителем заказчик <strong>обязан внести предоплату</strong></li>
 <li>Средства <strong>замораживаются</strong>через систему YuKassa до завершения работ</li>
 <li>Комиссия платформы: <strong>10%</strong>для стандартных услуг, <strong>15-25%</strong>для специальных</li>
 <li>Средства защищены от мошенничества с обеих сторон</li>
 </ul>
 </div>
 
 <div className="mt-4 bg-blue-50 p-4 rounded-lg border-l-4 border-blue-400">
 <h4 className="font-semibold text-blue-800 mb-3">1.2. Временные рамки и платежные операции:</h4>
 <ul className="list-disc list-inside space-y-2">
 <li><strong>Автоподтверждение:</strong>если заказчик не дает ответ в течение <strong>7 календарных дней</strong>, выполнение подтверждается автоматически</li>
 <li><strong>Доработка:</strong>заказчик может <strong>один раз</strong>вернуть задание на доработку напрямую; повторно — только через систему споров. На каждую доработку исполнителю даётся <strong>48 часов</strong></li>
 <li><strong>Выплаты:</strong>в течение 1-3 рабочих дней после подтверждения</li>
 <li><strong>Доплата при увеличении цены:</strong>немедленная блокировка через ЮКассу</li>
 <li><strong>Возврат при снижении цены:</strong>автоматически в течение 3-7 рабочих дней</li>
 </ul>
 </div>
 
 {/* НОВЫЙ РАЗДЕЛ - Изменение стоимости заданий */}
 <div className="mt-6">
 <h4 className="font-semibold text-purple-800 mb-3">1.3. Изменение стоимости заданий в процессе выполнения:</h4>
 
 <div className="grid md:grid-cols-2 gap-4">
 <div className="bg-purple-50 p-4 rounded-lg">
 <h5 className="font-semibold text-purple-800 mb-2">Механизм изменения цен:</h5>
 <ul className="list-disc list-inside text-sm space-y-1">
 <li>Любая из сторон может предложить изменение цены в чате</li>
 <li>Изменение требует согласия обеих сторон</li>
 <li>При увеличении - доплата через ЮКассу обязательна</li>
 <li>При снижении - автоматический частичный возврат</li>
 </ul>
 </div>
 
 <div className="bg-green-50 p-4 rounded-lg">
 <h5 className="font-semibold text-green-800 mb-2">Финансовые операции:</h5>
 <ul className="list-disc list-inside text-sm space-y-1">
 <li><strong>Доплаты:</strong>блокировка на отдельном эскроу-счете</li>
 <li><strong>Возвраты:</strong> 3-7 рабочих дней через ЮКассу</li>
 <li><strong>Комиссия:</strong>с итоговой суммы задания</li>
 <li><strong>Безопасность:</strong>все операции защищены</li>
 </ul>
 </div>
 </div>
 
 <div className="mt-4 p-3 bg-yellow-50 rounded text-sm">
 <p><strong>Важно:</strong>При спорных ситуациях администрация вправе заморозить все средства до урегулирования разногласий. Окончательные расчеты производятся на основании переписки и технического задания.</p>
 </div>
 </div>
 </div>

 {/* 2. Критерии качества медиафайлов */}
 <div>
 <h3 className="text-xl font-semibold text-gray-800 mb-4">Критерии качества медиафайлов</h3>
 
 <div className="grid md:grid-cols-2 gap-4">
 <div className="bg-green-50 p-4 rounded-lg">
 <h4 className="font-semibold text-green-800 mb-3">Качественные фото/видео:</h4>
 <ul className="list-disc list-inside text-sm space-y-1">
 <li>Четкость, отсутствие размытости</li>
 <li>Достаточная освещенность (объект различим)</li>
 <li>Соответствие заданию (правильное место/объект)</li>
 <li>Вертикальные фото для мобильной съемки допустимы</li>
 <li><strong>Минимальное разрешение:</strong> 1MP для фото, 720p для видео</li>
 </ul>
 </div>
 
 <div className="bg-red-50 p-4 rounded-lg">
 <h4 className="font-semibold text-red-800 mb-3">Некачественные материалы:</h4>
 <ul className="list-disc list-inside text-sm space-y-1">
 <li>Размытые, нечеткие изображения</li>
 <li>Слишком темные/засвеченные (объект неразличим)</li>
 <li>Не соответствуют заданию</li>
 <li>Разрешение менее 1MP/720p</li>
 <li>Посторонние объекты, закрывающие основной предмет съемки</li>
 </ul>
 </div>
 </div>
 </div>

 {/* 3. Сроки и ответственность */}
 <div>
 <h3 className="text-xl font-semibold text-gray-800 mb-4">Сроки и ответственность</h3>
 
 <div className="space-y-4">
 <div className="bg-orange-50 p-4 rounded-lg border-l-4 border-orange-400">
 <h4 className="font-semibold text-orange-800 mb-3">3.1. Нарушение сроков исполнителем:</h4>
 <ul className="list-disc list-inside space-y-2">
 <li>При <strong>просрочке более 24 часов</strong>без уведомления → заказчик может <strong>отменить задание</strong>с полным возвратом средств</li>
 <li><strong>Форс-мажор:</strong>исполнитель обязан <strong>уведомить заранее</strong>о задержке с указанием причины</li>
 <li>Уважительные причины: болезнь (медсправка), поломка оборудования, погодные условия</li>
 </ul>
 </div>
 
 <div className="bg-gray-50 p-4 rounded-lg border-l-4 border-gray-400">
 <h4 className="font-semibold text-gray-800 mb-3">3.2. Неявка заказчика на связь:</h4>
 <ul className="list-disc list-inside space-y-2">
 <li>Более <strong>7 дней</strong>без ответа на результаты → <strong>автоподтверждение</strong></li>
 <li>Средства перечисляются исполнителю администрацией в течение 3-7 рабочих дней</li>
 <li>Система отправляет напоминания на 3, 5 и 7 день</li>
 </ul>
 </div>
 </div>
 </div>

 {/* 4. Процедура проверки и доработки */}
 <div>
 <h3 className="text-xl font-semibold text-gray-800 mb-4">Процедура проверки и доработки</h3>
 
 <div className="bg-gradient-to-r from-blue-50 to-green-50 p-6 rounded-lg">
 <h4 className="font-semibold text-gray-800 mb-4">4.1. Алгоритм проверки:</h4>
 
 <div className="bg-white p-4 rounded border border-gray-200">
 <div className="text-center">
 <div className="flex items-center justify-center space-x-4 text-sm">
 <div className="bg-blue-100 px-3 py-2 rounded">Исполнитель сдает работу
 </div>
 <div className="text-gray-400">→</div>
 <div className="bg-yellow-100 px-3 py-2 rounded">Заказчик проверяет (до 7 дней)
 </div>
 </div>
 
 <div className="mt-4 space-y-2">
 <div className="flex items-center justify-center space-x-2 text-xs">
 <div className="bg-green-100 px-2 py-1 rounded">Принимает → Оплата исполнителю</div>
 </div>
 <div className="flex items-center justify-center space-x-2 text-xs">
 <div className="bg-yellow-100 px-2 py-1 rounded">Требует доработку → Указывает конкретные недостатки</div>
 </div>
 <div className="flex items-center justify-center space-x-2 text-xs">
 <div className="bg-red-100 px-2 py-1 rounded">Отклоняет → Подробное обоснование</div>
 </div>
 </div>
 </div>
 </div>
 </div>
 
 <div className="mt-4 bg-yellow-50 p-4 rounded-lg border-l-4 border-yellow-400">
 <h4 className="font-semibold text-yellow-800 mb-3">4.2. Правила доработки:</h4>
 <ul className="list-disc list-inside space-y-2">
 <li>Заказчик может <strong>один раз</strong>вернуть задание на доработку напрямую, без участия администратора, указав конкретные недостатки</li>
 <li>На доработку исполнителю даётся <strong>48 часов</strong></li>
 <li>Если после доработки результат снова не устраивает — заказчик открывает <strong>спор</strong>, решение принимает администратор (в том числе может повторно направить работу на доработку)</li>
 <li>Заказчик должен <strong>конкретно указать</strong>что не подходит</li>
 <li>Нечеткие требования ("сделайте лучше") не принимаются к рассмотрению</li>
 </ul>
 </div>
 </div>

 {/* 5. Система споров (уже реализована!) */}
 <div>
 <h3 className="text-xl font-semibold text-gray-800 mb-4">Система разрешения споров</h3>
 
 <div className="bg-purple-50 p-4 rounded-lg border border-purple-200">
 <p className="text-purple-800 font-semibold mb-2">Система споров полностью реализована в приложении!</p>
 <p className="text-sm text-purple-700">Пользователи могут открывать споры через раздел " Споры" в навигации. 
 Доступен полный функционал: создание спора, загрузка доказательств, 
 автоматическое и ручное рассмотрение.
 </p>
 </div>
 
 <div className="mt-4 grid md:grid-cols-2 gap-4">
 <div className="bg-green-50 p-3 rounded">
 <h4 className="font-semibold text-green-800 mb-2">Автоматическое разрешение:</h4>
 <ul className="list-disc list-inside text-sm space-y-1">
 <li>Анализ качества медиафайлов</li>
 <li>Проверка соответствия техническим требованиям</li>
 <li>Соблюдение временных рамок</li>
 </ul>
 </div>
 
 <div className="bg-blue-50 p-3 rounded">
 <h4 className="font-semibold text-blue-800 mb-2">Ручное рассмотрение:</h4>
 <ul className="list-disc list-inside text-sm space-y-1">
 <li>Сложные споры о качестве</li>
 <li>Нарушения правил платформы</li>
 <li>Конфликтные ситуации</li>
 </ul>
 </div>
 </div>
 </div>

 {/* 6. География и ограничения */}
 <div>
 <h3 className="text-xl font-semibold text-gray-800 mb-4">География и ограничения</h3>
 
 <div className="bg-blue-50 p-4 rounded-lg">
 <h4 className="font-semibold text-blue-800 mb-3">Ограничения по расстоянию:</h4>
 <ul className="list-disc list-inside space-y-2">
 <li><strong>Стандартные услуги:</strong>в пределах 50 км от местоположения исполнителя</li>
 <li><strong>Мобильный корреспондент:</strong>без ограничений (командировочные оплачиваются отдельно)</li>
 <li><strong>Выезд за город:</strong>дополнительная оплата транспортных расходов</li>
 <li>Исполнитель может самостоятельно устанавливать зоны обслуживания</li>
 </ul>
 </div>
 </div>

{/* Задания от организаций (B2B) */}
<div>
<h3 className="text-xl font-semibold text-gray-800 mb-4">Задания от организаций (B2B)</h3>
<div className="bg-blue-50 p-4 rounded-lg border-l-4 border-blue-400 space-y-3">
<p className="text-sm">Задания от организаций (B2B-задания) отмечаются специальным признаком. По ним оплата производится заказчиком-организацией напрямую исполнителю; денежные средства через Платформу не проходят, эскроу и возврат средств через Платформу к таким заданиям не применяются.</p>
<ul className="list-disc list-inside space-y-2 text-sm">
<li>Обмен платёжными реквизитами и номерами телефонов в чате B2B-задания является допустимым и не считается попыткой обхода Платформы. Переход в сторонние мессенджеры по-прежнему не рекомендуется: история чата на Платформе используется при рассмотрении споров.</li>
<li>Невыдача Исполнителем чека Заказчику по B2B-заданию является нарушением Правил. При подтверждённой жалобе применяются меры: первая — предупреждение; вторая — снятие бизнес-статуса с запретом повторной установки на 30 дней; третья — блокировка аккаунта.</li>
<li>Споры по B2B-заданиям рассматриваются в общем порядке в части качества и сроков выполнения. Возврат денежных средств через Платформу по B2B-заданиям невозможен; при решении спора в пользу Заказчика ему доступны действия «Закрыть задание» или «Открыть задание для новых исполнителей».</li>
</ul>
</div>
</div>


 {/* Заключительные положения */}
 <div className="border-t pt-4">
 <h4 className="font-semibold mb-3">Поддержка и вопросы</h4>
 <div className="bg-gray-50 p-4 rounded">
 <p className="text-sm">По всем вопросам применения правил платформы обращайтесь: 
 <a href="mailto:support@reversia.ru" className="text-blue-600 hover:underline ml-1">support@reversia.ru
 </a>
 </p>
 <p className="text-xs text-gray-500 mt-2">Ответ в течение 24 часов. Правила могут обновляться - следите за уведомлениями в приложении.
 </p>
 </div>
 </div>

 </div>
 </div>
 </div>
 );
};

